import { AlarmGroup } from 'path-shared/models/alarm-group';

export class AlarmeGpsFiltrat {
    id: string;
    data: string;
    tipus: AlarmGroup[] = new Array <AlarmGroup>();
  }
